<!-- MAIN TABLE ---------------------------------------------------->
<p-table
  #dt1
  [value]="userData?.data"
  dataKey="id"
  styleClass="p-datatable-customers p-datatable-gridlines "
  [paginator]="false"
>
  <ng-template pTemplate="caption">
    <div [formGroup]="form" class="page-control flex align-items-start">
      <div class="grid w-100">
        <div
          class="col-12 flex justify-content-between mb-2 align-items-center"
        >
          <h2 class="text-black-alpha-90">Analiza - Zastoj po operatoru</h2>
          <div class="flex">
            <button
              class="main-btn"
              [disabled]="!form.valid || !userData"
              (click)="onExportPdf()"
              [ngClass]="{ disabled: !form.valid || !userData }"
            >
              Export PDF <i class="pi pi-file-pdf"></i>
            </button>

       
          </div>
        </div>

        <div class="col-4">
          <div class="mb-0 flex">
            <p-calendar
              dateFormat="dd.mm.yy"
              class="filter-calendar w-full"
              placeholder="Datum od"
              (onSelect)="onSearch()"
              [showIcon]="true"
              formControlName="date_from"
            ></p-calendar>
            <button
              class="clear-btn ml-2"
              (click)="clearFilters('date_from')"
              pTooltip="Obriši filter"
              tooltipPosition="top"
            >
              <i class="pi pi-times m-0"></i>
            </button>
          </div>
        </div>

        <div class="col-4">
          <div class="mb-0 flex">
            <p-calendar
              dateFormat="dd.mm.yy"
              class="filter-calendar w-full"
              placeholder="Datum do"
              (onSelect)="onSearch()"
              [showIcon]="true"
              formControlName="date_to"
            ></p-calendar>

            <button
              class="clear-btn ml-2"
              (click)="clearFilters('date_to')"
              pTooltip="Obriši filter"
              tooltipPosition="top"
            >
              <i class="pi pi-times m-0"></i>
            </button>
          </div>
        </div>

        <div class="col-4">
          <div class="flex mb-0">
            <p-dropdown
              [options]="allUsers"
              formControlName="userId"
              optionValue="id"
              optionLabel="name"
              [filter]="true"
              [showClear]="false"
              placeholder="Izaberi radnika"
              class="w-100"
              (onChange)="onSearch()"
            >
            </p-dropdown>
            <button
              class="clear-btn ml-2"
              (click)="clearFilters('userId')"
              pTooltip="Obriši filter"
              tooltipPosition="top"
            >
              <i class="pi pi-times m-0"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header" >
    <tr *ngIf="userData">
      <th style="padding: 0.5rem">Datum</th>
      <th style="padding: 0.5rem" >Klijent</th>
      <th style="padding: 0.5rem">NIP broj</th>
      <th style="padding: 0.5rem">Količina</th>
      <th style="padding: 0.5rem">1 - Pauza / Ručak</th>
      <th style="padding: 0.5rem">2 - Pomoć - Prijem robe</th>
      <th style="padding: 0.5rem">3 - Pomoć - Utovar robe</th>
      <th style="padding: 0.5rem">4 - Kvar - Mašina (Alati)</th>
      <th style="padding: 0.5rem">5 - Nedostatak - Materijal</th>
      <th style="padding: 0.5rem">6 - Nedostatak - TD</th>
      <th style="padding: 0.5rem">7 - Sastanak </th>
      <th style="padding: 0.5rem">8 - Obuka radnika </th>
      <th style="padding: 0.5rem">9 - Ostalo </th>

    </tr>

  </ng-template>

  <ng-template pTemplate="body" let-user>
    <tr [ngClass]="user.color">
        <td >
          <span >{{ user.date }}</span>
        </td>
        <td >
          <span >{{ user.partner  }}</span>
        </td>
        <td>
            <span >{{ user.batch }}</span>
        </td>
        <td>
            <span >{{ user.required_units }}</span>
        </td>
    
        <td>
            <span >{{ user.lunch_break }}</span>
        </td>
        <td>
            <span >{{ user.help_reciving_package }}</span>
        </td>
        <td>
            <span >{{ user.help_delivery_package }}</span>
        </td>
        <td>
            <span >{{ user.failure}}</span>
        </td>
        <td>
            <span >{{ user.no_material
            }}</span>
        </td>
        <td>
            <span >{{ user.no_td }}</span>
        </td>
        <td>
          <span >{{user?.meeting}}</span>
      </td>
      <td>
        <span >{{user?.helping_colleague}}</span>
    </td>
        <td>
            <span >{{user?.other}}</span>
        </td>

        
      </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="10">Nema pronađenih prodataka.</td>
    </tr>
  </ng-template>
</p-table>

<!-- MAIN TABLE ---------------------------------------------------->

<div class="mt-4" *ngIf="userData">
    <p-table
      #dt1
      [value]="[userData]"
      dataKey="id"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[10, 25, 50]"
      [loading]=""
      styleClass="p-datatable-customers p-datatable-gridlines "
      [paginator]="false"
      class="mt-4"
    >
      <ng-template pTemplate="header" let-score>
        <tr>
          <th>
            <span></span>
          </th>
            <th style="padding: 0.5rem">1 - Pauza / Ručak</th>
            <th style="padding: 0.5rem">2 - Pomoć - Prijem robe</th>
            <th style="padding: 0.5rem">3 - Pomoć - Utovar robe</th>
            <th style="padding: 0.5rem">4 - Kvar - Mašina (Alati)</th>
            <th style="padding: 0.5rem">5 - Nedostatak - Materijal</th>
            <th style="padding: 0.5rem">6 - Nedostatak - TD</th>
            <th style="padding: 0.5rem">7 - Sastanak </th>
            <th style="padding: 0.5rem">8 - Obuka radnika</th>
            <th style="padding: 0.5rem">9 - Ostalo </th>
          
        </tr>
      </ng-template>
  
      <ng-template pTemplate="body" let-data>
        <tr>
          <td>
            <span>Ukupno u izabranom periodu [min]</span>
          </td>
          <td>
            <span>{{ data?.total_lunch_break }}</span>
          </td>
          <td>
            <span>{{ data?.total_help_reciving_package }}</span>
          </td>
          <td>
            <span>{{ data?.total_help_delivery_package }}</span>
          </td>
          <td>
            <span>{{ data?.total_failure }}</span>
          </td>
          <td>
            <span>{{ data?.total_no_material }}</span>
          </td>
          <td>
            <span>{{ data?.total_no_td }}</span>
          </td>
          <td>
            <span>{{ data?.total_meeting }}</span>
          </td>
          <td>
            <span>{{ data?.total_helping_colleague }}</span>
          </td>
          <td>
            <span>{{ data?.total_other }}</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>